import React from 'react' // eslint-disable-line no-unused-vars
import Select from '../../forms/Select'
import { api } from '../index.api'
import { COUNTRIES } from '../../constants'
import { addNotification as notify } from 'reapop'
import connect from 'react-redux/es/connect/connect'
import { validateField } from '../../pages/functions'
import ProductLabelUpdate from './ProductLabelUpdate'
import { formFieldsPerLanguage } from '../language/FormFieldsPerLanguage'
import Footer from '../Footer'
import AdminNavigation from './AdminNavigation'

class AdminProductUpdate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      productList: [],
      fields: {
        country: { name: 'country', value: '', rules: { title: 'Country', required: true } }
      }
    }

    formFieldsPerLanguage(this.state.fields, this.props.pageContent.content)
  }

    componentWillReceiveProps = nextProps => {
      formFieldsPerLanguage(this.state.fields, nextProps.pageContent.content)
    }

    handleCountryChange = value => {
      if (value) {
        const selectedCountry = this.countryList.filter(c => c.name === value)[0]
        const queryParams = {
          affiliate: selectedCountry.affiliate,
          country: value
        }
        api.admin.localProduct.getProductList(
          queryParams,
          this._getProductListSuccessHandler.bind(this),
          this._getProducListErrorHandler.bind(this)
        )
      }
    }

    _getProductListSuccessHandler = productList => {
      this.setState({ productList })
    }

    _getProducListErrorHandler = (error) => { /* eslint-disable-line */
      this._showNotification('Error', 'There seems to be some error while fetching products for selected country', 'error')
    }

    _validate = (e, field) => {
      const fields = validateField(e, field, this.state.fields)
      this.setState({ fields })

      return false
    }

    _showNotification = (title, message, status) => {
      const { notify } = this.props
      notify({
        title,
        message,
        status,
        position: 'tr',
        dismissible: true,
        dismissAfter: 6000
      })
    }

    render () {
      const languageContent = this.props.pageContent.content
      this.countryList = (this.props.referenceData.filter(function (item) {
        return (item.type === COUNTRIES)
      })[0]).countries
      this.countryOptions = this.countryList.map(function (country) {
        return {
          value: country.name,
          label: country.name
        }
      })

      return (
        <div className='page-container'>
          <div className='page-content'>
            <div className='v2_container'>
              <div className='row'>
                <AdminNavigation className='col-xl-2 col-lg-3 col-md-4 col-6' />
                <div className='col-xl-10 col-lg-9 col-md-8 col-6 p-l-15'>
                  <div className='row'>
                    <div className='col-12 col-xl-12'>
                      <h3 className='mb-3 header-primary'>{languageContent.module.admin.localProduct.heading}</h3>
                      <p>{languageContent.module.admin.localProduct.subheading}</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className=' col-md-4'>
                      <Select
                        searchable
                        clearable={false}
                        options={this.countryOptions}
                        field={this.state.fields.country}
                        onChange={this.handleCountryChange}
                        validate={(e, field) => this._validate(e, this.state.fields.country)}
                      />
                    </div>
                  </div>
                  <div className='row mt-4'>
                    {this.state.productList.map(product => {
                      return (
                        <div key={product.productCode} className='col-lg-4'>
                          <ProductLabelUpdate
                            product={product}
                            country={this.state.fields.country.value}
                            notify={this._showNotification}
                            languageContent={languageContent}
                          />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )
    }
}

function mapStateToProps (state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent
  }
}

export default connect(mapStateToProps, { notify })(AdminProductUpdate)



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AdminProductUpdate.js